/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Course201,
  PostApiV1Course400,
  PostApiV1Course401,
  PostApiV1Course404,
  PostApiV1Course500,
  PostApiV1CourseMutationRequest,
  PostApiV1CourseMutationResponse,
} from "../../types/courseRegistrationController/PostApiV1Course.ts";
import { courseDetailViewModelSchema } from "../courseDetailViewModelSchema.ts";
import { courseEditorViewModelSchema } from "../courseEditorViewModelSchema.ts";

/**
 * @description (Created) Objeto criado com sucesso.
 */
export const postApiV1Course201Schema = z.lazy(
  () => courseDetailViewModelSchema,
) as unknown as ToZod<PostApiV1Course201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Course400Schema =
  z.any() as unknown as ToZod<PostApiV1Course400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Course401Schema =
  z.any() as unknown as ToZod<PostApiV1Course401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1Course404Schema =
  z.any() as unknown as ToZod<PostApiV1Course404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Course500Schema =
  z.any() as unknown as ToZod<PostApiV1Course500>;

export const postApiV1CourseMutationRequestSchema = z.lazy(
  () => courseEditorViewModelSchema,
) as unknown as ToZod<PostApiV1CourseMutationRequest>;

export const postApiV1CourseMutationResponseSchema = z.lazy(
  () => postApiV1Course201Schema,
) as unknown as ToZod<PostApiV1CourseMutationResponse>;
